import React, { Component } from 'react';
import { connect } from 'react-redux';
import { removeCommittee, setCommitteeLoading } from '../actions';
import Loading from './loading-button';
import '../global';

class CommitteeRow extends Component {

	committeeButton() {
		if ( this.props.committeeLoading.length !== 0 ) {
			if ( this.props.committeeLoading.includes( this.props.ccode ) ) {
				return (<Loading classes="btn btn-primary join-committee-btn" />
				);
			}
		}
		if ( this.props.status === 'Request Sent' ) {
			return (
				<button type="button" name="cancel-request" onClick={ this.cancelRequest.bind( this, this.props.ccode ) } data-ccode={ this.props.ccode } data-party-id={ getPartyID() } class="btn btn-primary join-committee-btn cancel-request-btn">Cancel Request</button>
			);
		} else {
			return (
				<button type="button" name="leave-committee" onClick={ this.leaveCommittee.bind( this, this.props.ccode ) } data-ccode={ this.props.ccode } data-party-id={ getPartyID() } class="btn btn-primary join-committee-btn">Leave</button>
			);
		}
	}

	cancelRequest( ccode ) {
		this.props.setCommitteeLoading( ccode );
		let requestedCommittees = this.props.requestedCommittees.filter( committee => ccode !== committee.CODE );
		this.props.removeCommittee( requestedCommittees, ccode, getPartyID() );
	}

	leaveCommittee( ccode ) {
		this.props.setCommitteeLoading( ccode );
		let myCommittees = this.props.myCommittees.filter( committee => ccode !== committee.code );
		this.props.removeCommittee( myCommittees, ccode, getPartyID() );
	}

	getStatus( status ) {
		if ( status === 'MEMBLD' ) {
			return (<div>Committee Lead <br />
				<a href={ 'mailto:' + getDefaultEmail() + '?subject=Request Committee Lead Status Change' } class="committee-request-status-change" data-ccode={ this.props.ccode } data-party-id={ getPartyID() }>Request Status Change</a><i data-value="Remove as Committee Lead" data-ccode={ this.props.ccode } class="glyphicon glyphicon-envelope colleagues-mail-icon committee-colleague-email"></i>
			</div>
			);
		} else {
			return (<div>Committee Member</div>
			);
		}
	}

	render() {
		return (
			<div class="row no-gutter">
				<div className="col-xs-4">{ this.props.name }</div>
				<div className="col-xs-4">{ this.getStatus( this.props.status ) }</div>
				<div className="col-xs-4">
					<div class="leave-committee-btn-wrapper">
						{ this.committeeButton() }
					</div>
				</div>
			</div>


		);
	}

}

function mapStateToProps( { myCommittees, requestedCommittees, committeeLoading } ) {
	return {
		myCommittees, requestedCommittees, committeeLoading
	};
}

export default connect( mapStateToProps, {
	removeCommittee,
	setCommitteeLoading
} )( CommitteeRow );